import React from 'react'
import './service.css';
// import Card from '../card/Card';
import teamWork from '../../assets/teamWork.jpg';
import { BsArrowRightCircle } from 'react-icons/bs';



const Service = () => {
  return (
    <div className='service section_padding'>
      <h1 className='service__title'>Featured Projects</h1>
      <div className='container'>
        <div className='card'>
          <div className='card-container'>
           <div className='card__image'>
             <img src={teamWork} alt='' />
            </div>
            </div>
            <div className='card-hover'>
               <div className='card-hover-content'>
                <h1>Wells Fargo</h1>
                <p>A banking portal center for improving customer experience.</p>
              </div>
                 
              <div className='card-hover-icon'>
                 <a href='#home'><BsArrowRightCircle/></a>
              </div>
          </div>         
        </div>
        <div className='card'>
          <div className='card-container'>
           <div className='card__image'>
             <img src={teamWork} alt='' />
            </div>
          </div>         
            <div className='card-hover'>
               <div className='card-hover-content'>
                <h1>Wells Fargo</h1>
                <p>A banking portal center for improving customer experience.</p>
              </div>
                 
              <div className='card-hover-icon'>
                <a href='#home'><BsArrowRightCircle/></a>
              </div>
            </div>
        </div>
        <div className='card'>
          <div className='card-container'>
           <div className='card__image'>
             <img src={teamWork} alt='' />
            </div>
          </div>         
            <div className='card-hover'>
               <div className='card-hover-content'>
                <h1>Wells Fargo</h1>
                <p>A banking portal center for improving customer experience.</p>
              </div>
                 
              <div className='card-hover-icon'>
                <a href='#home'><BsArrowRightCircle/></a>
              </div>
            </div>
        </div>
        <div className='card'>
          <div className='card-container'>
           <div className='card__image'>
             <img src={teamWork} alt='' />
            </div>
          </div>         
            <div className='card-hover'>
               <div className='card-hover-content'>
                <h1>Wells Fargo</h1>
                <p>A banking portal center for improving customer experience.</p>
              </div>
                 
              <div className='card-hover-icon'>
                <a href='#home'><BsArrowRightCircle/></a>
              </div>
            </div>
        </div>
        
      </div>
    </div>
  )
}

export default Service